import { Trans } from 'react-i18next';
import { useCurrency } from '@/context/CurrencyContext/CurrencyContext';
import { useLanguage } from '@/hooks/useLanguage';
import { currentDomain } from '@/utils/branding';
import styles from './Terms.module.scss';

const useLegalParams = () => {
  const { country } = useCurrency();
  const { language } = useLanguage();
  const countryParam = country?.toLowerCase() === 'sa' ? 'sa' : 'ae';
  const langParam = language === 'ar' ? 'ar' : 'en';
  return { countryParam, langParam };
};

const Terms = () => {
  const { countryParam, langParam } = useLegalParams();

  return (
    <p className={styles.terms}>
      <Trans
        i18nKey="terms.fullMessage"
        values={{ domain: currentDomain }}
        components={{
          termsLink: (
            <a
              href={`/terms/${countryParam}/${langParam}`}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
          privacyLink: (
            <a
              href={`/privacy/${countryParam}/${langParam}`}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
        }}
      />
    </p>
  );
};

export default Terms;
